import { render, staticRenderFns } from "./UserPasswordChange.vue?vue&type=template&id=1384bf37&"
import script from "./UserPasswordChange.vue?vue&type=script&lang=js&"
export * from "./UserPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordChange.vue?vue&type=style&index=0&id=1384bf37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports